<template>
  <div class="navigation">
    <div class="leftside">
      <div class="logo">
        <!-- <a href="/"> -->
          <svg viewBox="0 0 808.9 147" xmlns="http://www.w3.org/2000/svg">
            <g fill="currentColor">
              <circle transform="rotate(-45.001 252.42 13.92)" cx="252.4" cy="13.9" r="13.9"/>
              <path d="M81.4 118.4c0 3.2-2.6 5.8-5.8 5.8H29.1c-3.2 0-5.8-2.6-5.8-5.8V18H0v86.5c0 24.1 19.6 42.4 42.4 42.4h21.1c21.5 0 41.2-18.5 41.2-42.4V18H81.4v100.4zM126.5 7.2h23.3v138.7h-23.3zm114.3 34.1h23.3v104.6h-23.3zM200.5 18h-23.2v23.2h-10.5v22.7h10.5v82h23.2v-82h23.3V41.3h-23.3zm297.9 23.3h-39.6v22.6h43.7c3.2 0 5.8 2.6 5.8 5.8v10.9h-36.6c-18.3 0-33.2 14.9-33.2 33.2s14.9 33.2 33.2 33.2h16.6c9.5 0 17.5-6.4 20-15v13.9h23.3V74.5c0-18.3-14.9-33.2-33.2-33.2zm9.9 77.2c0 3.2-2.6 5.8-5.8 5.8h-34.9c-3.2 0-5.8-2.6-5.8-5.8V105c0-3.2 2.6-5.8 5.8-5.8h40.7v19.3zm130.5-77.2h-26.9l-34.1 39.3H575V7.3h-23.3v138.6H575V99.2h2.8l39.9 46.6h28.8l-48.8-57zm-242.2 0H386c-11.1 0-20.4 7.9-22.4 18.5-3.6-10.8-13.2-18.5-25.2-18.5h-9c-10.4 0-19.1 6.9-21.9 16.4V43.6h-23.3v102.3h23.3V69.7c0-3.2 2.6-5.8 5.8-5.8h23.3c3.2 0 5.8 2.6 5.8 5.8v76.2h23.3V69.7c0-3.2 2.6-5.8 5.8-5.8h23.3c3.2 0 5.8 2.6 5.8 5.8v76.2h23.3V68.5c-.1-15-12.3-27.2-27.3-27.2zm399.3 0c-10.3 0-19.1 6.7-22.1 16.1V43.6h-23.3v102.3h23.3V69.7c0-3.2 2.6-5.8 5.8-5.8h29.1V41.3h-12.8z"/>
              <path d="m689.9 40.2h-4.6c-24.7 0-44.6 20-44.6 44.6v9.1c0 28.7 23.3 51.9 51.9 51.9h21.6v-21.6h-22.7c-14.6 0-26.6-10.8-28.3-24.9h71.3v-14.5c0.1-24.7-19.9-44.6-44.6-44.6zm-27.7 40.7c2.6-11.6 13-20.2 25.4-20.2s22.7 8.6 25.4 20.2h-50.8z"/>
            </g>
          </svg>
        <!-- </a> -->
      </div>
    </div>
    <div class="rightSide">
      <p>Ultimaker Showroom</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navigtaion',
  setup() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/Layout/Navigation";
</style>
